import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Connects to data-controller="country-select"
export default class extends Controller {
  static targets = ["countrySelect", "provinceSelect"]
  static values = {
    country: String,
    province: String
  }

  connect() {
    if (this.hasCountryValue && this.countryValue) {
      this.loadStatesForCountry(this.countryValue, this.provinceValue)
    } else if (this.countrySelectTarget?.value) {
      this.loadStatesForCountry(this.countrySelectTarget.value)
    }
  }

  async updateStates(event) {
    const countryCode = event.target.value
    this.loadStatesForCountry(countryCode)
  }

  async loadStatesForCountry(countryCode, selectedProvince = null) {
    const provinceSelect = this.provinceSelectTarget

    if (!provinceSelect) return

    provinceSelect.innerHTML = '<option value="">Seleccionar provincia</option>'
    provinceSelect.disabled = true

    if (!countryCode) {
      return
    }

    try {
      const response = await get("/receptionist/patients/states", {
        responseKind: "json",
        query: { country_code: countryCode }
      })

      const states = await response.json

      if (states && states.length > 0) {
        states.forEach(([name, code]) => {
          const option = document.createElement("option")
          option.value = code
          option.textContent = name
          if (selectedProvince && code === selectedProvince) {
            option.selected = true
          }
          provinceSelect.appendChild(option)
        })
        provinceSelect.disabled = false
      } else {
        provinceSelect.innerHTML = '<option value="">No aplica</option>'
        provinceSelect.disabled = false
      }
    } catch (error) {
      console.error("Error carga de provincias:", error)
    }
  }
}
